<template>
    <dashboard v-if="event">
        <heading :wrap-buttons="true">
            <h1 slot="page-title">Event Detail</h1>
            <h2 slot="title">{{ event.title }}</h2>

            <app-tag v-if="event.is_in_session" slot="tag" type="success">In Session</app-tag>
            <app-tag v-if="event.is_archived" 
                     slot="tag" 
                     type="danger" 
                     size="small">Archived</app-tag>
            <template slot="buttons">
                <app-button v-if="event.is_in_session" @click="openEventAttendance">QR Code</app-button>
                <app-button @click="showEditEvent = true">Edit Event</app-button>
            </template>
        </heading>
        <info-bar>
            <div class="info-bar-column">
                <span class="title">Location</span>
                <span>
                    <div v-if="event.location" class="event-location">
                        <router-link
                            v-if="$role.isAdmin()"
                            :to="locationPath">{{ event.location.name }}</router-link>
                        <template v-else>{{ event.location.name }}</template>
                    </div>
                    <template v-else>No Location</template>
                </span>
            </div>
            <div class="info-bar-column">
                <span class="title">Time</span>
                <span>
                    {{ [ event.start_time, "HH:mm:ss" ] | moment("h:mma") }}
                    - {{ [ event.end_time, "HH:mm:ss" ] | moment("h:mma") }}
                </span>
            </div>
            <div class="info-bar-column">
                <span class="title">Date</span>
                <span>{{ event.date | moment("MM/DD/YYYY") }}</span>
            </div>
            <div v-if="event.public_url" class="info-bar-column">
                <span class="title">Sign Up URL</span>
                <span>
                    <a :href="event.public_url">{{ event.public_url }}</a>
                </span>
            </div>
        </info-bar>
        <row>
            <link-list :routes="routes"/>
            <router-view :event="event" />
        </row>

        <modal v-model="showEditEvent">
            <event-edit-view :event_id="event.id" />
        </modal>

        <section class="event-attendance">
            <event-attendance v-if="fullscreen" :event="event" />
        </section>

        <modal v-model="mobileFullscreen">
            <event-attendance :event="event" />
        </modal>
    </dashboard>
</template>
<script>
import { mapGetters } from 'vuex'
import { get, comb, isMobile } from '@/utilities'
import Event from '@/store/models/Event'

import refreshes from '@/mixins/refreshes'

import InfoBar from '../../ui/InfoBar'
import EventEditView from './EventEditView'
import EventAttendance from './EventAttendance'

export default {
    name: 'page-events-detail',
    components: {
        InfoBar,
        EventEditView,
        EventAttendance
    },
    mixins: [refreshes],
    props: ['uuid'],
    head: {
        title() {
            return {
                inner: comb('Event', '-', get(this, 'event.title'))
            }
        }
    },
    data() {
        return {
            showEditEvent: false,
            fullscreen: false,
            mobileFullscreen: false,
            seconds: 15,
            tableParamKeys: ['uuid'],
            routes: [
                {
                    title: 'Dashboard',
                    name: 'events.detail.dashboard',
                    icon: 'icon-dashboard'
                },
                {
                    title: 'Attending',
                    name: 'events.detail.students',
                    icon: 'icon-students'
                },
                {
                    title: 'Waitlist',
                    name: 'events.detail.waitlist',
                    icon: 'icon-waitlist'
                },
                {
                    title: 'Users',
                    name: 'events.detail.users',
                    icon: 'icon-users'
                }
            ]
        }
    },
    computed: {
        event() { return Event.findUuid(this.uuid) },
        hasBeacons() {
            return get(this, 'event.location.has_beacons')
        },
        ...mapGetters(['role']),
        locationPath() {
            return {
                name: 'locations.detail',
                params: { id: this.event.location_id }
            }
        }
    },
    created() {
        this.getEvent()
    },
    methods: {
        getEvent() {
            Event.$fetchOne({ uuid: this.uuid })
                .then(() => {
                    this.$emit('updateHead')
                })
                .catch(() => {
                    this.$router.push({ name: 'events' })
                })
        },
        openEventAttendance() {
            if (isMobile()) {
                this.mobileFullscreen = true
            }
            else {
                this.$fullscreen.toggle(this.$el.querySelector('.event-attendance'),
                    {
                        wrap: false,
                        callback: this.fullscreenChange
                    })
            }
        },
        fullscreenChange(fullscreen) {
            this.fullscreen = fullscreen
        },
        tick() {
            if (this.showEditEvent) return
            this.getEvent()
        }
    },
    watch: {
        uuid() {
            this.getEvent()
        }
    }
}
</script>

<style lang="stylus">
.dashboard
    .el-table .cell, .el-table th div
        padding-right: 5px

        .status-block
            margin-left: -5px
            margin-right: -5px

.event-location
    display: inline-block
</style>
